import React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfModal from '@/components/UI/Modal';

interface RuleModalProps {
    currNotes: any;
    setCurrNotes: (currNotes?: string[] | null) => void;
}

const RuleModal: React.FC<RuleModalProps> = ({ currNotes, setCurrNotes }) => {
    const { useLang } = useGlobal();
    const { t } = useLang('ecocredits');
    return (
        <EfModal
            className={css.efmodal}
            visible={!!currNotes}
            zIndex={1200}
            onCancel={() => {
                setCurrNotes(null);
            }}
        >
            <div className="rule-content">
                <h5 className="rule-title">{t('notice_title')}</h5>
                <ul>
                    {currNotes?.map((note: string, index: number) => (
                        <li key={index} className="rule-item">
                            {note}
                        </li>
                    ))}
                </ul>
            </div>
        </EfModal>
    );
};

export default RuleModal;
